import { useEffect, useState } from "react";
import { service } from "../services/service";
import { Button, Col, Row, Table, Select, Popconfirm } from "antd";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DeleteOutlined } from "@ant-design/icons";

function TablesLeads() {
  const [tableValue, setTableValue] = useState([]);
  const [campaignName, setCampaignName] = useState([]);

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Surname",
      dataIndex: "surname",
      key: "surname",
    },
    {
      title: "Municipality",
      dataIndex: "municipality",
      key: "municipality",
    },
    {
      title: "Agency",
      dataIndex: "agency",
      key: "agency",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (value) => <div style={{ maxWidth: "200px" }}>{value}</div>,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Related Campaign",
      dataIndex: "id_campaign",
      key: "campaign name",
      render: (value) => value.name,
    },
    {
      title: "Action",
      dataIndex: "",
      key: "x",
      render: (a, b, c) => (
        <Popconfirm
          title="Delete Lead"
          description="Are you sure to delete this Lead?"
          onConfirm={() => {
            service.deleteLead(a.id);
          }}
          okText="Yes"
          cancelText="No"
        >
          <Button
            type="deafult"
            style={{ color: "red" }}
            icon={<DeleteOutlined />}
          />
        </Popconfirm>
      ),
    },
  ];

  function getDate() {
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    return `${date}_${month}_${year}`;
  }

  useEffect(() => {
    const loggedStorage = localStorage.getItem("user");
    if (loggedStorage === null) {
      window.location.assign("/login");
    }
  }, []);

  useEffect(() => {
    getTable();
    getCampaign();
  }, []);

  function getTable() {
    let temp = [];
    let i, k;
    service.getLeadTable().then((res) => {
      for (i = 0; i < res.length; i++) {
        for (k = 0; k < res[i].id_leads.length; k++) {
          temp.push(res[i].id_leads[k]);
        }
      }
      setTableValue(temp);
    });
  }

  function getCampaign() {
    service.getLeadTable().then((res) => {
      setCampaignName(res.map(({ name }) => ({ label: name, value: name })));
    });
  }

  function saveExel() {
    const worksheet = XLSX.utils.json_to_sheet(tableValue);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Buffer to store the generated Excel file
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(blob, `conctacts_${getDate()}.xlsx`);
  }

  function onChange(value) {
    service.getLeadInCampagin(value).then((res) => {
      setTableValue(res);
    });
  }

  return (
    <>
      <Row justify="end">
        <Col span={2}>
          <h1 style={{ margin: 0 }}>Leads</h1>
        </Col>
        <Col span={6}>
          <Select
            onChange={(value, potion) => {
              onChange(value);
            }}
            style={{ flex: 1, width: "100%" }}
            options={campaignName}
            autoClearSearchValue
          ></Select>
        </Col>
        <Col span={3} offset={13} style={{ textAlign: "end" }}>
          <Button
            type="primary"
            onClick={() => saveExel()}
            style={{ marginBottom: "10px" }}
          >
            Export
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={tableValue}
            pagination={{ defaultCurrent: 1 }}
          />
        </Col>
      </Row>
    </>
  );
}
export default TablesLeads;
// aggiungere un check per scaricare i selezionati
